import { Component } from '@angular/core';

@Component({
  selector: 'app-dash-component-user',
  templateUrl: './dash-component-user.component.html',
  styleUrls: ['./dash-component-user.component.css']
})
export class DashComponentUserComponent {

}
